import * as React from 'react';
import styles from './sidebarCardHeader.module.css';
export const SidebarCardHeader = ({ children }) => {
    return React.createElement("div", { className: styles.SidebarCardHeader }, children);
};
